import React from 'react';
import c from 'classnames';

interface Props {
    message: React.ReactNode;
    type?: 'ERROR' | 'WARNING';
}
export default function Error({ message, type = 'ERROR' }: Props) {
    return <span className={c('text-xs', type === 'ERROR' ? 'text-red-500' : 'text-yellow-600')}>{message}</span>;
}
